import { useState } from 'react';
import { X, Copy, Check, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePromoBanner } from '@/hooks/usePromoBanner';
import { useToast } from '@/hooks/use-toast';

export function PromoBanner() {
  const { showBanner, settings, discountCode, dismissBanner, formattedMessage } = usePromoBanner();
  const { toast } = useToast();
  const [copied, setCopied] = useState(false);

  if (!showBanner || !discountCode) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(discountCode.code);
      setCopied(true);
      toast({
        title: "Code copied!",
        description: `${discountCode.code} has been copied to your clipboard.`,
      });
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast({
        title: "Failed to copy",
        description: "Please copy the code manually.",
        variant: "destructive",
      });
    }
  };

  const bgColor = settings?.background_color || '#C7A875';
  const textColor = settings?.text_color || '#20324A';

  return (
    <div 
      className="w-full py-2 px-4 flex items-center justify-center gap-3 relative z-50"
      style={{ backgroundColor: bgColor, color: textColor }}
    >
      <div className="flex items-center gap-2 text-sm font-medium">
        <Sparkles className="h-4 w-4" />
        <span>{formattedMessage}</span>
        <Button
          variant="ghost"
          size="sm"
          onClick={handleCopy}
          className="h-6 px-2 ml-1 hover:bg-white/20"
          style={{ color: textColor }}
        >
          {copied ? (
            <Check className="h-3 w-3" />
          ) : (
            <Copy className="h-3 w-3" />
          )}
          <span className="ml-1 text-xs font-bold">{discountCode.code}</span>
        </Button>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={dismissBanner}
        className="absolute right-2 h-6 w-6 p-0 hover:bg-white/20"
        style={{ color: textColor }}
        aria-label="Dismiss banner"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
